import * as React from "react"
import { useEffect } from "react"
import { object, array } from "yup"
import { useValidatorSeeker } from "@ui-seeker/app"

import { batch } from "@preact/signals-react"

import { CommonFilters } from "@components"
import { DATE_PERIODS } from "@constants"
import { country, currentPeriod, dateRange, dateRangePeriod, disabledCommonFiltersSubmit, retailer } from "@signals"


export default function AdminNewListedFilters({ onSubmit }) {

	const { isValid, errors } = useValidatorSeeker({ country: country.value, retailer: retailer.value }, object({
		...(!country.value.length && !retailer.value.length) && {
			country: array().min(1, 'At least one of country be provided'),
			retailer: array().min(1, 'At least one of retailer be provided')
		}
	}))

    useEffect(() => {
        disabledCommonFiltersSubmit.value = !isValid
    }, [isValid]);

	// Esta pantalla se trabaja por periodo, no por día: enseña los productos **vistos por primera
	// vez** en el rango, y el mapeo se hace sobre lo acumulado. Por defecto, los últimos 30 días.
	// ⚠️ `dateRangePeriod` YA viene resuelto para `currentPeriod` (su objeto acaba en
	// `}[currentPeriod.value]`): indexarlo por el periodo da `undefined` y `startDate` revienta en
	// `dateRange.value[0]`. Es el mismo orden que usa `setCommonFilters`.
	useEffect(() => {
		batch(() => {
			currentPeriod.value = DATE_PERIODS.LAST_30_DAYS
			dateRange.value = dateRangePeriod.value
		})
	}, []);

	useEffect(() => {
       return () => disabledCommonFiltersSubmit.value = false
    }, []);

	return <CommonFilters
		components={{
			country: true, site: true,
			category: true, brand: true,
			validated: true
		}}
		compProps={{
			country: { grid: { md: 6 }, error: errors?.country},
			site: { grid: { md: 6 }, error: errors?.retailer },
			category: { grid: { md: 3 }, placement: 'bottomStart' },
			brand: { grid: { md: 6 } }
		}}
		onSubmit={onSubmit}
	/>
}